export default class UpdateWorkScopeSpecificationError extends Error {
    
}